module.exports = __webpack_public_path__ + "static/img/discount-riseup-friends.2fcedb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discount-riseup-friends.svg
// module id = 7yFu
// module chunks = 6